import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { DASHBOARD_ERROR_REPORT } from './TranslationValues';
import { API_ERROR_MESSAGES } from '../../utils/translationValues';
import { ERROR } from '../../utils/constants/apiStatusCodeMap';

const DocumentError = styled.div`
  .data-validation-error {
    h5 {
      font-weight: bold;
      font-size: 18px;
    }
    ul {
      padding-left: 1rem;
      list-style: outside;
      .bold {
        font-weight: bold;
      }
    }
  }
`;

const dataValidationErrorCodes = [3100, 3101, 3102, 3103, 3104, 3106];

const NAMESPACES = ['DASHBOARD_ERROR_REPORT'];

export const DashboardErrorReport = ({ failureDetails }) => {
  const { t } = useTranslation(NAMESPACES);
  if (!failureDetails) {
    return <></>;
  }
  const failureSplit = failureDetails.split(' : ');
  const failureCode = Number(failureSplit[0]);
  const isFailureCodeValid = failureCode && !isNaN(failureCode);
  let dataValidationErrors;
  let errorKey;
  if (isFailureCodeValid) {
    if (dataValidationErrorCodes.includes(failureCode)) {
      dataValidationErrors = JSON.parse(failureSplit[1]);
    }
    errorKey = ERROR[failureCode];
  }
  const { errors } = dataValidationErrors || {};

  return (
    <DocumentError>
      {errors ? (
        <div className="data-validation-error">
          <h5>
            {t(
              DASHBOARD_ERROR_REPORT.DATA_VALIDATION_ERROR_LABEL.key,
              DASHBOARD_ERROR_REPORT.DATA_VALIDATION_ERROR_LABEL.value,
            )}
          </h5>
          <ul>
            {errors?.barcode39 ? (
              <li>
                <span className="bold">{errors?.barcode39?.join(', ')}</span>
                {` - ${t(
                  DASHBOARD_ERROR_REPORT.BARCODE39_VALUE_ERROR_MESSAGE.key,
                  DASHBOARD_ERROR_REPORT.BARCODE39_VALUE_ERROR_MESSAGE.value,
                )}`}
              </li>
            ) : null}
            {errors?.chartValue ? (
              <li>
                <span className="bold">{errors?.chartValue?.join(', ')}</span>
                {` - ${t(
                  DASHBOARD_ERROR_REPORT.CHART_VALUE_ERROR_MESSAGE.key,
                  DASHBOARD_ERROR_REPORT.CHART_VALUE_ERROR_MESSAGE.value,
                )}`}
              </li>
            ) : null}
            {errors?.mandatory ? (
              <li>
                <span className="bold">{errors?.mandatory?.join(', ')}</span>
                {` - ${t(
                  DASHBOARD_ERROR_REPORT.MANDATORY_ERROR_MESSAGE.key,
                  DASHBOARD_ERROR_REPORT.MANDATORY_ERROR_MESSAGE.value,
                )}`}
              </li>
            ) : null}
            {errors?.length ? (
              <li>
                <span className="bold">{errors?.length?.join(', ')}</span>
                {` - ${t(
                  DASHBOARD_ERROR_REPORT.MAX_CHARACTERS_ERROR_MESSAGE.key,
                  DASHBOARD_ERROR_REPORT.MAX_CHARACTERS_ERROR_MESSAGE.value,
                )}`}
              </li>
            ) : null}
            {errors?.dateFormat ? (
              <li>
                <span className="bold">{errors?.dateFormat?.join(', ')}</span>
                {` - ${t(
                  DASHBOARD_ERROR_REPORT.DATE_FORMAT_ERROR_MESSAGE.key,
                  DASHBOARD_ERROR_REPORT.DATE_FORMAT_ERROR_MESSAGE.value,
                )}`}
              </li>
            ) : null}
            {errors?.empty ? (
              <li>
                <span className="bold">{errors?.empty?.join(', ')}</span>
                {` - ${t(
                  DASHBOARD_ERROR_REPORT.EMPTY_ERROR_MESSAGE.key,
                  DASHBOARD_ERROR_REPORT.EMPTY_ERROR_MESSAGE.value,
                )}`}
              </li>
            ) : null}
          </ul>
        </div>
      ) : isFailureCodeValid && errorKey ? (
        <div>
          {t(
            `API_ERROR_MESSAGES:${API_ERROR_MESSAGES[errorKey].key}`,
            API_ERROR_MESSAGES[errorKey].value,
          )}
        </div>
      ) : (
        <div>{failureDetails}</div>
      )}
    </DocumentError>
  );
};
